const translations = {
  is: {
    checkout: {
      checking_out_label: 'Fara í greiðsluferli...',
      checkout_label: 'Fara í greiðsluferli',
      continue_shopping_label: 'Halda áfram að versla',
      view_cart_label: 'Skoða körfu',
      size: 'Stærð',
      color: 'Litur',
      total: 'Samtals',
    },
    smart_cart: {
      cart_title_singular: 'Karfa <span class="cart-item-count">{{count}} vara</span>',
      cart_title_plural: 'Karfa <span class="cart-item-count">{{count}} vörur</span>',
    },
    announcement_bar: {
      bars: [
        {
          free_shipping_remaining: "Þig vantar {{remaining_amount}} upp á til að fá fría sendingu",
          free_shipping_reached: "Þú hefur fengið fría sendingu",
        }
      ]
    },
    empty: {
      title: 'Karfan þín er tóm',
      button: "Versla núna"
    }
  }
};

const updateTranslations = () => {
  const locale = Shopify?.locale;
  const translation = translations[locale] ?? translations.en;

  // use this element to append a notice if we are in the US market
  const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label');

  if (locale && translation) {
    if (Rebuy && translation.checkout) {      
      Rebuy.SmartCart.getCheckoutSettings().language = translation.checkout;
    }

    const cartDrawer = document.querySelector('.rebuy-cart');

    if (cartDrawer) {
      const cartTitle = cartDrawer.querySelector('.rebuy-cart__title');

      if (cartTitle && translation.smart_cart) {
        const itemsCount = Rebuy.SmartCart.cart.item_count;

        if (itemsCount > 1) {
          cartTitle.innerHTML = translation.smart_cart.cart_title_plural.replace("{{count}}", itemsCount);
        } else {
          cartTitle.innerHTML = translation.smart_cart.cart_title_singular.replace("{{count}}", itemsCount);
        }
      }
    }

    let totalText = document.querySelector(".rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-label > span");
    
    if (totalText) {
      totalText.textContent = translation.checkout.total;
    }  
  }

};

const checkCartVariants = () => {
  const locale = Shopify?.locale;
  const translation = translations[locale] ?? translations.en;

  if (locale && translation) {

    const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    
    cartItems.forEach(cartItem => {
     
      const variantElements = cartItem.querySelectorAll('.rebuy-cart__flyout-item-variant');
      const variantCount = variantElements.length;
      
      console.log(`Cart item has ${variantCount} variants`);
      
      if (variantCount === 1) {
        // Single variant - color only
        const spanElement = variantElements[0].querySelector('span');
        if (spanElement) {
          spanElement.textContent = translation.checkout.color;
        }
      } else if (variantCount === 2) {
        // Two variants - size, color
        const firstSpan = variantElements[0].querySelector('span');
        const secondSpan = variantElements[1].querySelector('span');
        
        if (firstSpan) {
          firstSpan.textContent = translation.checkout.size;
        }
        if (secondSpan) {
          secondSpan.textContent = translation.checkout.color;
        }
      }
    });
  }
};

const updateEmptyCartTranslations = () => {
  const locale = Shopify?.locale;
  const translation = translations[locale] ?? translations.en;

  if (locale && translation) {
    const emptyCartTitle = document.querySelector('.rebuy-cart__flyout-empty-cart h4');
    const emptyCartButton = document.querySelector('.rebuy-cart__flyout-empty-cart p a');

    if(emptyCartTitle && emptyCartButton) {
      emptyCartTitle.innerHTML = translation.empty.title;
      emptyCartButton.innerHTML = translation.empty.button;
    }
  }
};

const updateAnnouncementBar = () => {
  const locale = Shopify?.locale;
  const announcementTranslations = translations[locale]?.announcement_bar?.bars;
  const components = Rebuy.SmartCart.settings.components;

  if (announcementTranslations) {
    const announcementBar = components.find(c => c.type === 'tiered_progress_bar')

    if(!announcementBar) {
      return;
    }

    announcementBar.settings.bars.forEach((bar, index) => {
      const translation = announcementTranslations[index];

      if (translation) {
        bar.language = translation;
      }
    });
  }
}

// Update Smart Cart with locale translations
document.addEventListener('rebuy:smartcart.ready', () => {
  updateTranslations();
  updateAnnouncementBar();
  checkCartVariants();
  addUSNote();

  // Every 100ms update translations
  setInterval(() => {
    updateTranslations();
    updateEmptyCartTranslations();
  }, 50);
});

document.addEventListener('rebuy:cart.change', () => {
  updateTranslations();
  updateEmptyCartTranslations();
  updateAnnouncementBar();
  checkCartVariants();
  addUSNote();
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
  updateTranslations();
});


// add a note about taxes and duties for US market
const addUSNote = () => {
  
  // parent element to append the note to
  const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label');

  const existingNote = document.querySelector('.rebuy-cart__flyout-subtotal-note');
  
  if (Shopify?.country === 'US' && subtotalLabel && !existingNote) {
    const note = document.createElement('span');
    note.className = 'rebuy-cart__flyout-subtotal-note';
    note.textContent = '(Taxes and Duties not included)';
    note.style.display = 'block'; 
    note.style.fontSize = '11px';
    note.style.color = '#B1B3B3';
    subtotalLabel.appendChild(note);
  }
};
